export class BusinessUnitDto {
  id: string;
  createdBy: string;
  creationDate: Date;
  modifiedBy: string;
  modificationDate: Date;
  code: string;
  label: string;
  address: string;
  address1: string;
  address2: string;
  city: string;
  country: string;
  email: string;
  telephone: string;
}